// components/partner/PartnerFilter.tsx
import React, { useEffect, useState } from "react";
import TableFilterBar from "../common/TableFilterBar";
import TablePartner from "../common/TablePartner";
import { PaginationData } from "../../types/pagination";
import { useStore } from "../../app/stores/store";
import { PagingParams } from "../../types/pagination";
import { all_routes } from "../router/all_routes";
import { dialogFlags } from "../../constants/constants";
import Paginator from "../common/Paginator";

type PartnerListProps = {
  pagination: PaginationData | null;
  pageSize?: number | null;
  handlePageSizeChange?: (newPageSize: number) => void;
  searchQuery?: string;
  setSearchQuery?: (query: string) => void;
  bookingCode?: string;
  setBookingCode?: (code: string) => void;
  handleSearch?: () => void;
  handleReset: () => void;
};
const PartnerList = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedId, setSelectedId] = useState<string | null>(null);
  const [pageSize, setPageSize] = useState(10);
  const {
    userStore: {
      loadPendingPartners,
      setSearchTerm,
      setPagingParams,
      pagination,
      partners,
    },
  } = useStore();

  useEffect(() => {
    setPagingParams(new PagingParams(1, pageSize));
    loadPendingPartners();
  }, [pageSize]);

  const handlePageSizeChange = (newPageSize: number) => {
    setPageSize(newPageSize);
    setPagingParams(new PagingParams(1, newPageSize));
    loadPendingPartners();
  };

  const handleGetNext = (page: number) => {
    setPagingParams(new PagingParams(page, pageSize));
    loadPendingPartners();
  };

  const handleSearch = () => {
    setSearchTerm(searchQuery);
    setPagingParams(new PagingParams(1, pageSize));
    loadPendingPartners();
  };

  const handleReset = () => {
    setSearchTerm("");
    setSearchQuery("");
    setPagingParams(new PagingParams(1, pageSize));
    loadPendingPartners();
  };

  return (
    <div className="bg-none flex justify-center items-start px-4 py-4 w-full">
      <div className="w-full max-w-[1200px]">
        <div className="flex flex-col gap-4">
          {/* Filter Bar */}
          <TableFilterBar
            pagination={pagination}
            pageSize={pageSize}
            handlePageSizeChange={handlePageSizeChange}
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
            handleSearch={handleSearch}
            handleReset={handleReset}
          />

          {/* Partner Table */}
          <div className="flex flex-col w-full overflow-x-auto bg-white rounded-lg shadow-sm">
            <TablePartner
              dialogFlags={dialogFlags}
              setSelectedId={setSelectedId}
              exceptColumns={[
                "id",
                "companyLogoPath",
                "tradeLicensePath",
                "createdDate",
              ]}
              data={partners ?? []}
              pageSize={pageSize}
              rowsPerPageOptions={[10, 25, 50]}
              routeUrl={all_routes.PartnerDashboard}
            />

            {/* Paginator */}
            <div className="flex justify-center pt-4">
              <Paginator
                handleGetNext={handleGetNext}
                pagination={pagination}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PartnerList;
